<ng-template #menuButtons>
    <p-button class="**:w-full flex justify-center" label="Profil" icon="pi pi-user" iconPos="left"
        severity="secondary" (click)="goToProfile()" />
    <p-button *ngIf="user.roles?.includes('administration')" class="**:w-full flex justify-center"
        label="Profil bearbeiten" icon="pi pi-user-edit" iconPos="left" severity="secondary"
        (click)="goToProfileEdit()" />
    <p-button *ngIf="user.roles?.includes('administration') || user.isSystemAdmin"
        class="**:w-full flex justify-center" label="Home" icon="pi pi-home" iconPos="left"
        severity="secondary" (click)="goToHomePage()" />
    <p-button *ngIf="user.roles?.includes('administration') || user.isSystemAdmin"
        class="**:w-full flex justify-center" label="Admin" icon="pi pi-wrench" iconPos="left"
        severity="secondary" (click)="goToAdminPage()" />
    <p-divider *ngIf="user.isSystemAdmin || (user.roles?.includes('administration'))"></p-divider>
    <p-button *ngIf="(user.isSystemAdmin || user.roles?.includes('administration')) && !sessionData?.actor"
        class="**:w-full flex justify-center" [label]="'impersonate.button' | translate" icon="pi pi-user-edit" iconPos="left"
        severity="warning" (click)="openImpersonateDialog()" />
    <p-button *ngIf="sessionData?.actor"
        class="**:w-full flex justify-center" [label]="'impersonate.end_button' | translate" icon="pi pi-sign-out" iconPos="left"
        severity="danger" (click)="endImpersonation()" />
    <p-button class="**:w-full flex justify-center" label="Abmelden" icon="pi pi-sign-out" iconPos="left"
        severity="secondary" (click)="logout()" />
</ng-template>

<div class="card user-menu-trigger" style="padding: 0.25rem">
    <button type="button" class="layout-topbar-action" (click)="showDialog('topright')">
        <i class="pi pi-user"></i>
        <span>{{ 'common.profile' | translate }}</span>
    </button>

    <p-dialog [showHeader]="false" [(visible)]="visible" [position]="position" [closable]="true"
        [style]="{ width: '15rem', marginTop: '5rem' }" [modal]="false" appendTo="body"
        styleClass="user-menu-dialog">
        <h5 style="margin-top: 1rem; text-align: center;">Benutzermenü</h5>
        <div class="flex flex-col justify-end gap-2 mt-1">
            <ng-container [ngTemplateOutlet]="menuButtons"></ng-container>
        </div>
    </p-dialog>
</div>

<div class="user-menu-inline">
    <ng-container [ngTemplateOutlet]="menuButtons"></ng-container>
</div>
